module.exports = __webpack_public_path__ + "static/media/twitter-x-logo.da8b829f.png";